module.exports = __webpack_public_path__ + "static/media/sin-complicaciones-cajas-01.e1d03fa2.svg";